import React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 active:scale-[0.98] gap-2",
  {
    variants: {
      variant: {
        default: "bg-primary text-white hover:bg-primary-hover focus-visible:ring-primary",
        accent: "bg-accent text-primary font-bold hover:bg-accent-hover focus-visible:ring-accent",
        secondary: "bg-background text-text-main border border-border hover:bg-border/60 focus-visible:ring-border",
        outline: "border border-border bg-surface hover:bg-background text-text-main",
        ghost: "hover:bg-background text-text-main",
        danger: "bg-danger text-white hover:bg-danger/90 focus-visible:ring-danger",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 px-3 text-xs",
        lg: "h-11 px-6",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: { variant: "default", size: "default" },
  }
);

export const Button = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp className={cn(buttonVariants({ variant, size }), className)} ref={ref} {...props} />
    );
  }
);
Button.displayName = "Button";

export { buttonVariants };
